import SaveSaleButton from './SaveSaleButton';

export default SaveSaleButton;